import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import instance from "../../../../../axios/instance"
import InstantMeetingRoom from "../../compomnents/InstantMeetingRoom"


export default function InstantMeetingContainer() {

    const location = useLocation()

    const [loading, setLoading] = useState(false)
    const [token, setToken] = useState("")

   


    async function getAgoraToken() {
        setLoading(true)
        instance.post("/telemedicine/agora/token", {
            uid: location.state.doctor_id,
            channelName: location.state.channel_name
        })
        .then(response => {
            console.log("token is",response.data); 
            setToken(response.data.token)
            setLoading(false)
        })
        .catch(error => {
            console.log(error.response.data);
            setLoading(false)
        })
    }

    useEffect(() => {

        console.log(location);
        
        getAgoraToken()
    }, [])

    if (loading || !token) {
        return <div>Getting token</div>
    }


    return (
        <div>
            { token && <InstantMeetingRoom token={token} meetingData={location.state} /> }
        </div>
    )
}